<template>
<loader v-bind="{ loading }">
  <div class="tabs">
    <ul>
      <router-link exact tag="li" :to="{ name: 'vulnerability-manager', params: { vulnerability: $route.params.vulnerability }}">
        <a>Overview</a>
      </router-link>
      <router-link tag="li" :to="{ name: 'vulnerability-poc', params: { vulnerability: $route.params.vulnerability }}">
        <a>Proof of Concept</a>
      </router-link>
      <router-link exact tag="li" :to="{ name: 'vulnerability-versions', params: { vulnerability: $route.params.vulnerability }}">
        <a>Product Versions</a>
      </router-link>
      <router-link exact tag="li" :to="{ name: 'vulnerability-distributions', params: { vulnerability: $route.params.vulnerability }}">
        <a>Distributions</a>
      </router-link>
      <router-link exact tag="li" :to="{ name: 'vulnerability-edit', params: { vulnerability: $route.params.vulnerability }}">
        <a>Edit</a>
      </router-link>
    </ul>
  </div>
  <router-view />
</loader>
</template>
<script>
export default {
  
  data: () => ({
    loading: true
  }),

  beforeCreate() {
    this.$store.dispatch('vulnerability/loadVulnerability', this.$route.params.vulnerability).then(() => {
      this.loading = false
    })
  }


}
</script>